<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-lg-8 col-sm-12">
          <div class="element-box mb-0">
            <form @submit="refresh">
              <h5 class="form-header">
                REQUERIMIENTOS 
              </h5>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.producto &&
                          current.errors.producto.length > 0,
                      }"
                    ></label>
                    <ProductoSelectComponentV2
                      @onChangeProducto="onChangeProducto"
                      :current="current"
                    ></ProductoSelectComponentV2>
                    <small
                      v-if="current.errors && current.errors.producto"
                      class="form-text text-danger"
                      >{{ current.errors.producto[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-md-12">
                  <TiendaSelectComponent :current="current" />
                </div>
               
                
              </div>
              <div class="form-buttons-w">
                <button class="btn btn-md btn-success" type="submit">
                  Refrescar
                </button>
                <router-link
                  v-if="current.producto_obj"
                  class="btn btn-outline-info"
                  :to="{
                    name: 'cat-productos-editar',
                    params: { sku: current.producto_obj.sku },
                  }"
                >
                  <i class="fa fa-arrow-left"></i>
                  Ir al Producto
                </router-link>
              </div>
            </form>

            <div class="row">
              <div class="col-sm-12"></div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 col-sm-12 pt-2 color-scheme-dark"
          v-if="current.producto_obj"
        >
          <ProductoTiendaTableComponent
            v-if="current.producto_obj"
            :current="current.producto_obj"
            :filtrartienda="current.tienda"
            @refresh="refresh"
          />
        
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div class="table-responsive">
                  <div class="text-right">
                    <span class="status-pill smaller green"></span>&nbsp;Abierta
                    <span class="status-pill smaller yellow"></span
                    >&nbsp;Para Despacho
                    <span class="status-pill smaller red"></span>&nbsp;Anulada
                  </div>
                <table class="table table-bordered table table-striped">
                  <thead>
                    <tr>
                      <th>
                        Numero
                      </th>
                      <th>
                        Fecha 
                      </th>
                      <th>
                        Cantidad Requerida
                      </th>
                      <th>
                        Pendiente Asignar
                      </th>
                      <th>
                        Carrito
                      </th>
                      <th>
                        Estacion
                      </th>
                      <th>
                        Enviado
                      </th>
                      <th>
                        Estado
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.req_id">
                      <td>
                        <span>{{
                          item.numero
                        }}</span>
                      </td>
                      <td>
                          <timeago
                            :title="item.fecha_creacion"
                            :datetime="item.fecha_creacion"
                           ></timeago>
                      </td>
                      <td> 
                        <span>{{
                          item.CtReq
                        }}</span>
                      </td>
                      <td> 
                        <span v-if="item.EstadoSol == '9'">{{
                          0
                        }}</span>
                        <span v-if="item.EstadoSol != '9'">{{
                          item.CtReq+item.CtPosicion 
                        }}</span>
                      </td>
                      <td> 
                        <span>{{
                          item.CtCarrito
                        }}</span>
                      </td>
                      <td> 
                        <span>{{
                          item.CtEstacion
                        }}</span>
                      </td>
                      <td> 
                        <span>{{
                          (item.CtPosicion+item.CtEstacion+item.CtCarrito)*-1
                        }}</span>
                      </td>
                      <td class="text-center">
                          <span
                            class="status-pill smaller green"
                            v-if="item.EstadoSol == 'A'"
                          ></span>
                          <span
                            class="status-pill smaller yellow"
                            v-if="item.EstadoSol == 'B'"
                          ></span>
                          <span
                            class="status-pill smaller red"
                            v-if="item.EstadoSol == '9'"
                          ></span>
                        </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import ProductoTiendaTableComponent from "@/components/cat/productos/ProductoTiendaTableComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProductoSelectComponentV2,
    ProductoTiendaTableComponent,
  },
  data() {
    return {
      current: {
        producto: null,
        producto_obj:null,
        fecha_final: null,
        fecha_inicial: null,
        tienda: null,
        errors: {
          productos: null,
          fecha_inicial: null,
          fecha_final: null,
        },
      },
      datos: [],
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.tienda) {
        this.current.tienda = this.$route.params.tienda;
        this.refresh();
      }
    },
  },
  mounted() {
    let self = this;
    if (this.$route.params.sku) {
      self.refreshProductoDefault(this.$route.params.sku);
      self.refreshProducto(this.$route.params.sku);
      
    }
    if (this.$route.params.tienda) {
      self.current.tienda = this.$route.params.tienda;
    }
  },
  methods: {
    onChangeProducto(producto) {
      let self = this;
      self.refreshProducto(self.current.producto.sku);
      
      // self.refreshUnidadMedida(producto);
    },
    refreshProductoDefault(sku) {
      let self = this;
      ProductosService.getById(sku).then((response) => {
        self.current.producto = response.data;
      });
    },
    refreshProducto(sku) {
      let self = this;
      ProductosService.getById(sku).then((response) => {
        self.current.producto_obj = response.data;
      });
    },
    refresh(e) {
      if (e) {
        e.preventDefault();
      }
      let self = this;
      let params = Object.assign({}, self.current);
      if (params.fecha_inicial) {
        params.fecha_inicial = moment(params.fecha_inicial).format(
          "DD/MM/YYYY"
        );
      }
      if (params.fecha_final) {
        params.fecha_final = moment(params.fecha_final).format("DD/MM/YYYY");
      }
      if (params.fecha_inicial == null){
        delete params.fecha_inicial;
      }
      DynamicService.postAction(
        "cat",
        "productos",
        self.current.producto_obj.sku,
        "requerimientos",
        params
      )
        .then((res) => {
          self.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
